import { TextField } from '@mui/material';
import { BaseFieldWrapper } from './BaseFieldWrapper';
import { CommentProperties } from 'src/api/process-module';
import { Field } from 'src/API';
import { TEST_IDS } from 'src/test-ids';

interface CommentFieldProps {
  field: Field;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  fieldProps?: CommentProperties;
}

export const CommentField = ({ field, value, onChange, disabled = false, fieldProps }: CommentFieldProps) => {
  return (
    <BaseFieldWrapper label={field.label} required={fieldProps?.required} fieldProps={fieldProps}>
      <TextField
        fullWidth
        multiline
        rows={fieldProps?.rows || 4}
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        // placeholder={fieldProps?.placeholder || "not working1"}
        placeholder={fieldProps?.placeholder}
        variant="outlined"
        inputProps={{ 'data-testid': TEST_IDS.COMMENT_FIELD.INPUT }}
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: 'background.paper',
            '& fieldset': {
              borderColor: 'rgba(0, 0, 0, 0.12)',
            },
            '&:hover fieldset': {
              borderColor: 'rgba(0, 0, 0, 0.24)',
            },
            '&.Mui-focused fieldset': {
              borderColor: 'primary.main',
            },
          },
        }}
      />
    </BaseFieldWrapper>
  );
};
